import { HonorariumLiquidationStatusId } from '../../dto/HonorariumLiquidationDTO';

interface LiquidationStatusTagProps {
    statusId: number;
    /** Descripción que manda el backend ("Abierta", "Cerrada"). */
    status: string;
}

/** Estado de la liquidación (DS §3.4): abierta = se puede modificar, cerrada = terminada. */
export default function LiquidationStatusTag({ statusId, status }: LiquidationStatusTagProps) {
    const variant = statusId === HonorariumLiquidationStatusId.OPEN ? 'md-tag-warn' : 'md-tag-mut';
    return <span className={`md-tag ${variant}`}>{status}</span>;
}
